import React from 'react';
import { Link } from 'react-router-dom';

const Avatar = ({ user }) =>
  user.picture ? (
    <img src={user.picture} alt="" referrerPolicy="no-referrer" className="w-16 h-16 rounded-full object-cover border-2 border-gold-400" />
  ) : (
    <span className="w-16 h-16 rounded-full bg-gold-400 text-[#143160] text-2xl font-bold flex items-center justify-center">{(user.name || 'U').charAt(0)}</span>
  );

export const UserBadge = ({ user }) => (
  <>
    <div className="flex items-center space-x-4 mb-8">
      <Avatar user={user} />
      <div>
        <h1 className="font-serif text-3xl text-[#143160]">Welcome, {user.name?.split(' ')[0] || 'friend'}!</h1>
        <p className="text-neutral-500 text-sm">{user.email}</p>
      </div>
    </div>
    {user.role === 'admin' && (
      <Link to="/admin/leads" data-testid="account-admin-link" className="inline-block mb-8 bg-[#143160] text-white font-bold px-5 py-2.5 rounded-lg hover:bg-[#1E4A86]">Go to Leads Dashboard →</Link>
    )}
  </>
);
